<template>
  <b-alert
    style="width: 100%;"
    class="m-0 my-25 mx-75 py-25"
    variant="secondary"
    show
  >
    <div class="p-0 alert-body text-center">
      <small>La notificación <b>llegará a todos los usuarios del sistema</b></small>
    </div>
  </b-alert>
</template>

<script>
import {
  BAlert,
} from 'bootstrap-vue'

export default {
  components: {
    BAlert,
  },
}
</script>
